import _each from "lodash/each";
import store from "~/js/store/store";
import "focus-visible";
import { Cubic, gsap, Quint } from "gsap";
import Common from "~/js/common/common";
export default class Footer {
  constructor() {
    this.view = document.querySelector(".l-footer");
    this.pagetop = document.querySelector(".js-pagetop");
    this.site_search = document.getElementById("f_site_search");
    this.brandOthersIndex = this.getBrandOthersSectionIndex();
    this.movePagetopOutOfMain();
    this.setup();
    this.setupPagetop();
    this.setupSubnavi();
    this.setupScroll();
    this.setSiteSearch();
  }

  /**
   * PINセクションページではmainにtransformがかかりposition:fixedが効かないため
   * Page Topボタンをbody直下に移動する
   */
  movePagetopOutOfMain() {
    if (this.brandOthersIndex < 0 || !this.pagetop) return;
    document.body.appendChild(this.pagetop);
  }

  /**
   * ブランドトップ「もっと知る」セクション (.c-brands-others) のインデックスを取得
   * 該当セクションが存在しない場合（ブランドトップ以外のページ等）は -1 を返す
   * PinSection.getSections() と同じフィルタリングロジックを適用する
   */
  getBrandOthersSectionIndex() {
    const allSections = [...document.querySelectorAll('.js-section')];
    const sections = allSections.filter(section => {
      const onlySp = !!section.getAttribute('data-onlysp');
      return !(onlySp && !Common.isTabletSize());
    });
    return sections.findIndex(el => el.classList.contains('c-brands-others'));
  }

  setSiteSearch() {
    if (this.site_search) {
      //検索時に、tagを付与してsubmit
      this.site_search.addEventListener('submit', this.onSiteSearchSubmitHandler.bind(this));
    }
  }

  onSiteSearchSubmitHandler(evt) {
    evt.preventDefault();
    this.site_search.q.value = this.site_search.q.value+" "+this.site_search.free_word.value.replace(/　/g," ");
    this.site_search.submit()
  }

  setupScroll() {
    this.view.addEventListener("scroll", (e) => {
      store.dispatch("footerScroll");
      if (e.currentTarget.scrollTop <= 0) {
        if (store.state.app.pinSection.isScrolling) {
          return;
        }
        store.dispatch("changePinScroll", {
          index: store.state.app.pinSection.nextIndex - 1
        });
      }
    });
  }

  setup() {
    store.subscribe((mutation, state) => {
      if (mutation.type === "scrollY") {
        if (!this.pagetop) {
          return;
        }
        // ブランドトップではbeforeScrollで制御するためscrollYは無視
        if (this.brandOthersIndex >= 0) {
          return;
        }
        if (window.innerHeight <= state.app.scrollY) {
          this.pagetop.classList.add("active");
        } else {
          this.pagetop.classList.remove("active");
        }
      }

      // ブランドトップ: 「もっと知る」セクション以降でPage Topボタンを表示
      if (mutation.type === "beforeScroll" && this.brandOthersIndex >= 0) {
        if (!this.pagetop) {
          return;
        }
        if (state.app.pinSection.nextIndex >= this.brandOthersIndex) {
          this.pagetop.classList.add("active");
        } else {
          this.pagetop.classList.remove("active");
        }
      }
    });
  }

  /**
   * Page Topボタンの設定
   */
  setupPagetop() {
    if (!this.pagetop) {
      return;
    }
    this.pagetop.addEventListener("click", (event) => {
      event.preventDefault();
      if (store.state.app.scrollYPin) {
        store.dispatch("changePinScroll", {
          index: parseInt(0, 10)
        });
      } else {
        gsap.to(window, {
          delay: 0.3,
          duration: 0.8,
          ease: Quint.easeInOut,
          scrollTo: {
            y: 0
          }
        });
      }
    });
  }

  /**
   * サブナビ開閉
   */
  setupSubnavi() {
    const toggleButtons = this.view.querySelectorAll(".js-footertoggle");
    _each(toggleButtons, (elm, index) => {
      let target = elm.getAttribute("data-target");
      if (!target) {
        return;
      }
      // let targetElms = this.view.querySelectorAll(target);
      elm.addEventListener("click", (event) => {
        event.preventDefault();
        if (Common.isSPSize()) {
          this.gotoLink(target);
        }
        /*if (target && targetElms) {
          _each(targetElms, (_elm) => {
            this.toggleSubnaviOpen(_elm, elm);
          });
        }*/
      });
    });
  }

  gotoLink(link) {
    location.href = link;
  }

  setupSubnaviContents(elm) {
    let links = elm.querySelectorAll("a");
    gsap.set(links, {
      opacity: 0
    });
  }

  // Toggle Subnavi Open
  toggleSubnaviOpen(target, button) {
    if (!target) {
      return;
    }
    let isOpen = target.classList.toggle("open");
    let links = target.querySelectorAll("a");
    if (isOpen) {
      button.classList.add("open");
      /*_each(links, (elm, index) => {
        gsap.fromTo(elm, {
          opacity: 0,
        }, {
          opacity: 1,
          duration: 0.5,
          delay: 0.06 * index,
          ease: Cubic.easeOut
        })
      })*/
    } else {
      button.classList.remove("open");
      /*_each(links, (elm, index) => {
        gsap.set(elm, {
          opacity: 0
        })
      })*/
    }
  }
}
